'use client';

import { useCallback, useEffect, useState } from 'react';

import {
  EVMNft,
  EvmNFTChain,
  EvmNFTCollectionContractName,
} from '@repo/types-client';

import { getEvmNfts } from '../utils';

export interface UseEvmNftsAlchemyProps {
  addresses?: string[];
  collections?: EvmNFTCollectionContractName[];
  chain: EvmNFTChain;
}

export const useEvmNftsOnchain = ({
  addresses,
  collections,
  chain,
}: UseEvmNftsAlchemyProps) => {
  const [data, setData] = useState<EVMNft[]>();
  const [loading, setLoading] = useState<boolean>(false);
  const [error, setError] = useState<string | null>(null);

  const fetchEvmNfts = useCallback(async () => {
    if (!addresses?.length || !collections?.length) {
      return;
    }

    setLoading(true);
    try {
      const response = await getEvmNfts({
        addresses,
        collections: collections,
        chain,
        dataSource: 'onchain',
      });
      setData(response);
      // eslint-disable-next-line @typescript-eslint/no-explicit-any
    } catch (error: any) {
      setError(error.toString());
      setData(undefined);
    } finally {
      setLoading(false);
    }
  }, [addresses, collections, chain]);

  useEffect(() => {
    fetchEvmNfts();
  }, [addresses, collections, fetchEvmNfts]);

  return { data, loading, error };
};
